export enum ApplicationErrorType {
	DispatchBoardError = 'Board Error',
	NoTerminals = 'No Terminals',
	NotFound = 'Page Not Found',
	TerminalNotFound = 'Terminal Not Found',
	Unauthorized = 'Unauthorized',
	Unavailable = 'Unavailable',
	Unexpected = 'Error'
}

export enum ApplicationErrorActions {
	Back = 'Back',
	Custom = 'Custom',
	Home = 'Home',
	Refresh = 'Refresh'
}

export interface IErrorDetails {
	type: ApplicationErrorType;
	title: string;
	message: string;
	useContactSupportMessage: boolean;
	action?: ApplicationErrorActions;
	customAction?: CustomErrorAction;
}

export interface CustomErrorAction {
	action: () => void;
	buttonText: string;
}

/**
 * Centralized class used by ApplicationError to retrieve various properties of the given error type.
 */
export class ErrorDetails implements IErrorDetails {
	constructor(type: ApplicationErrorType, messageParam?: string, customAction?: CustomErrorAction) {
		this.type = type;

		switch (type) {
			case ApplicationErrorType.DispatchBoardError:
				this.title = ApplicationErrorType.DispatchBoardError;
				this.message = `Unable to retrieve any legs for Terminal ${messageParam ?? 'Unknown'}. Please try again.`;
				this.useContactSupportMessage = false;
				this.action = ApplicationErrorActions.Custom;
				this.customAction = customAction;
				break;

			case ApplicationErrorType.NoTerminals:
				this.title = ApplicationErrorType.NoTerminals;
				this.message = 'You currently do not have access to any terminals.';
				this.useContactSupportMessage = true;
				this.action = ApplicationErrorActions.Refresh;
				break;

			case ApplicationErrorType.Unauthorized:
				this.title = ApplicationErrorType.Unauthorized;
				this.message = 'You currently do not have access to this application.';
				this.useContactSupportMessage = true;
				this.action = ApplicationErrorActions.Refresh;
				break;

			case ApplicationErrorType.NotFound:
				this.title = ApplicationErrorType.NotFound;
				this.message = 'The page you are looking for could not be found or you do not have access to it.';
				this.useContactSupportMessage = true;
				this.action = ApplicationErrorActions.Home;
				break;

			case ApplicationErrorType.TerminalNotFound:
				this.title = `Terminal ${messageParam ?? 'Unknown'} Not Found`;
				this.message = `Terminal ${messageParam ?? 'Unknown'} could not be found or you do not have access to it.`;
				this.useContactSupportMessage = true;
				this.action = ApplicationErrorActions.Home;
				break;

			case ApplicationErrorType.Unavailable:
				this.title = ApplicationErrorType.Unavailable;
				this.message = 'The application is currently unavailable.';
				this.useContactSupportMessage = true;
				this.action = ApplicationErrorActions.Refresh;
				break;

			default:
				this.title = ApplicationErrorType.Unexpected;
				this.message = 'An unexpected error has occurred.';
				this.useContactSupportMessage = true;
				this.action = ApplicationErrorActions.Home;
				break;
		}
	}

	type: ApplicationErrorType;
	title: string;
	message: string;
	useContactSupportMessage: boolean;
	action?: ApplicationErrorActions;
	customAction?: CustomErrorAction;
}
